import React from 'react';

function InlineChromiumBugfix() {

  const spanAttributes = {
    contentEditable: false,
    style: {
      fontSize: 0
    }
  };

  return <span {...spanAttributes}>
    ${String.fromCodePoint(160)}
  </span>;

}

export default InlineChromiumBugfix;